import { request } from '@/shared/api/request'

export const approveMembers = (externalId, iin, isEmployee) => {
	return request({
		url: `colcontract/tradeUnion/person/approve/${externalId}?iin=${iin}&isEmployee=${isEmployee}`,
		method: 'POST',
	})
}
